import React from 'react';
import CheckboxInput from 'shared/components/CheckboxInput';
import Label from 'shared/components/Label';
import Tooltip from 'shared/components/Tooltip';

const Scoring = (props) => {
  const name = 'scoring';

  const {
    parameters,
    onChangeParameter,
    groupName,
    label,
    tooltip
  } = props;

  const onChange = e => onChangeParameter(name, e.target.checked ? '1' : '0');

  const checked = parameters && parameters[name] === '1';

  return (
    <div>
      <CheckboxInput
        inputId={name}
        inputClassName="mr-2"
        name={name}
        groupName={groupName}
        checked={checked}
        onChange={onChange} />
      <Label htmlFor={name} label={label}>
        <Tooltip id={`tooltip-${name}`} title={tooltip} />
      </Label>
    </div>
  );
};

Scoring.defaultProps = {
  label: Spree.translations.parameters.scoring,
  tooltip: Spree.helpForParameters.scoring,
};

export default Scoring;
